var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaniumLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 424 76",
    viewBox: "0 0 424 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 75.6,
    maskUnits: "userSpaceOnUse",
    width: 75.1,
    x: 0,
    y: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.1.4h75v75.6h-75z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.3 32.5h51.8c-2.7-18.1-18.4-32.1-37.3-32.1-20.9 0-37.8 17-37.8 37.8s16.9 37.8 37.8 37.8c1.8 0 3.6-.1 5.3-.4v-31.2h-19.8z",
    fill: "#cf2a2b",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.1 70.7c9.4-5.6 16.1-15.1 17.9-26.3h-17.9z",
    fill: "#cf2a2b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fbfbfc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.2 21.6h48.4v10.6h-17.9v32.2h-12.7v-32.2h-17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.2 47.6h16.2l-8.2-16.1zm-.3-26h16.5l22.8 42.9h-14.1l-3.9-7.6h-25.7l-3.7 7.6h-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.6 21.6h19.7l23.8 31.1h.1v-31.1h12.7v42.8h-19.6l-23.9-31.1h-.1v31.1h-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262 64.4h12.7v-42.8h-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.9 21.6h12.7v24.7c0 5.4 1.9 7.6 7.1 7.6h12.6c5.2 0 7.1-2.1 7.1-7.6v-24.7h12.6v27.6c0 10.7-5.3 15.7-17 15.7h-18.2c-11.7 0-17-5.1-17-15.7v-27.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.4 21.6h19.5l14.4 27.6 14.3-27.6h19.5v42.8h-12.3v-30.7h-.1l-16.7 30.7h-9.5l-16.6-30.7h-.1v30.7h-12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423 61.1-1 2.8h-.5l-1-2.8v2.8h-.7v-3.6h1.1l.9 2.4.9-2.4h1.1v3.6h-.8zm-5.9-.1h-1.1v-.6h2.9v.6h-1.1v3h-.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaniumLogo);
export default __webpack_public_path__ + "static/media/tanium_logo.ba14dd8c22b05154d9a64f09142e6fc2.svg";
export { ForwardRef as ReactComponent };